module.exports = {
  contributionComponentEvents: {
    ContributionDetails: {
      code: 'ContributionDetails',
      events: {
        ContributionDetails: {
          description: 'Triggered when the contribution details submitted',
          eventHub: {
            action: 'ContributionDetails',
            dataKeys: ['totalAmount', 'frequency', 'bankAccount', 'startDate']
          },
          ga: {
            action: 'Contribution Details'
          }
        },
        ContributionDetailsError: {
          description: 'Triggered when the contribution details field has an error',
          eventHub: {
            action: 'ContributionDetailsError',
            dataKeys: ['totalAmount', 'frequency', 'bankAccount', 'startDate']
          },
          ga: {
            action: 'Contribution Details Error'
          }
        }
      }
    },
    VerifyContribution: {
      code: 'VerifyContribution',
      events: {
        Review: {
          description: 'Triggered when user click Confirm button from review screen',
          eventHub: {
            action: 'Review',
            dataKeys: []
          },
          ga: {
            action: 'Confirm Contribution'
          }
        },
        Somethingwentwrong: {
          description: 'Triggered when user click Confirm button from verify contribution and fail',
          eventHub: {
            action: 'Somethingwentwrong',
            dataKeys: []
          },
          ga: {
            action: 'Contribution Fail'
          }
        }
      }
    },
    ContributionSuccess: {
      code: 'ContributionSuccess',
      events: {
        Success: {
          description: 'Triggered when user click Done button from success screen',
          eventHub: {
            action: 'Success',
            dataKeys: []
          },
          ga: {
            action: 'Success'
          }
        }
      }
    },
    PACSuccess: {
      code: 'PACSuccessPage',
      events: {
        PACSuccessPage_OnLoad: {
          description: 'Contribution Success Page On Load',
          eventHub: {
            action: 'PACSuccessPage_OnLoad'
          }
        },
        PACSuccessPage_OnClickDone: {
          description: 'Triggered when user click Done button from success screen',
          eventHub: {
            action: 'PACSuccessPage_OnClickDone'
          }
        },
        PACSuccessPage_OnClickPolicyMe: {
          description: 'Triggered when user click Policy Learn more button',
          eventHub: {
            action: 'PACSuccessPage_OnClickPolicyMe'
          }
        },
        PACSuccessPage_OnClickWillful: {
          description: 'Triggered when user click Willful Learn more button',
          eventHub: {
            action: 'PACSuccessPage_OnClickWillful'
          }
        }
      }
    }
  }
};
